// src/assessment2/Assessment2Layout.js — Assessment 2 (PLAN_ASSESSMENT2.md)
// Punto de entrada de la sección. Aplica el gate (super-admin + organización
// habilitada) y monta el layout copiado del módulo de evaluaciones.
import React from 'react';
import { Navigate } from 'react-router-dom';
import useStore from '../config/store';
import EvaluationLayout from './EvaluationLayout';
import { canUseAssessment2 } from './assessment2Access';

const Assessment2Layout = () => {
  const { user, organization } = useStore();

  if (!canUseAssessment2({ user, organization })) {
    return <Navigate to="/home" replace />;
  }

  return <EvaluationLayout />;
};

export default Assessment2Layout;
